/**
 * Turns a failed authentication-service call into messages the dialogs can show. The service answers
 * errors as `{ error: { message, subErrors: [{ object, field, message }] } }`: `message` is English,
 * a sub-error's `message` is Arabic for the organization-user refusals (its `object` is the stable
 * code, e.g. USER_IN_OTHER_ORGANIZATION) and the validation message for bean-validation failures.
 */
export interface FormError {
  field?: string;
  code?: string;
  message: string;
}

export const parseApiErrors = (error: unknown, fallback: string): FormError[] => {
  const apiError = (error as { error?: Record<string, unknown> })?.error;
  const subErrors = apiError?.subErrors;
  if (Array.isArray(subErrors) && subErrors.length > 0) {
    return subErrors.map((sub: Record<string, string | undefined>) => ({
      field: sub.field || undefined,
      code: sub.object,
      message: sub.message || (apiError?.message as string) || fallback,
    }));
  }
  if (typeof apiError?.message === "string") {
    return [{ message: apiError.message }];
  }
  return [{ message: fallback }];
};
